import { useSiteContent } from '@/__lib/SiteContentProvider';
import { strings } from '@/i18n/strings';
import { CtaBand } from '@components/__shared/CtaBand/CtaBand';
import { RichText } from '@components/__shared/RichText/RichText';
import { Seo } from '@components/__shared/Seo/Seo';
import { SocialIcon } from '@components/__shared/SocialIcon/SocialIcon';
import styles from './Contact.module.scss';

export const Contact = () => {
	const { siteMeta, contactContent } = useSiteContent();

	const mapQuery =
		contactContent.mapQuery.trim() ||
		[...siteMeta.addressLines, `${siteMeta.city}, ${siteMeta.country}`].join(', ');
	const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(mapQuery)}&z=15&hl=cs&output=embed`;

	return (
		<>
			<Seo
				title={strings.contact.seoTitle}
				description={strings.contact.seoDescription(siteMeta.businessName, siteMeta.city)}
				path="/kontakt"
			/>

			<section className={styles.intro}>
				<div className={styles.introInner}>
					{contactContent.eyebrow.trim() && <p className={styles.eyebrow}>{contactContent.eyebrow}</p>}
					<h1>{contactContent.headline}</h1>
					<RichText className={styles.introBody} html={contactContent.intro} />
				</div>
			</section>

			<section className={styles.body}>
				<div className={styles.bodyInner}>
					<div className={styles.details}>
						<div className={styles.block}>
							<h2>{strings.contact.address}</h2>
							<address>
								{siteMeta.addressLines.map((line, index) => (
									<span key={index}>{line}</span>
								))}
								<span>
									{siteMeta.city}, {siteMeta.country}
								</span>
							</address>
						</div>

						<div className={styles.block}>
							<h2>{strings.contact.getInTouch}</h2>
							<p>
								<a href={`tel:${siteMeta.phone.replace(/\s+/g, '')}`}>{siteMeta.phone}</a>
							</p>
							<p>
								<a href={`mailto:${siteMeta.email}`}>{siteMeta.email}</a>
							</p>
						</div>

						<div className={styles.block}>
							<h2>{strings.contact.followAlong}</h2>
							<div className={styles.socials}>
								{siteMeta.socials.map(social => (
									<a key={social.url} href={social.url} target="_blank" rel="noreferrer">
										<SocialIcon label={social.label} className={styles.socialIcon} />
										{social.label}
									</a>
								))}
							</div>
						</div>
					</div>

					<iframe
						className={styles.map}
						title={strings.contact.mapTitle}
						src={mapSrc}
						loading="lazy"
						allowFullScreen
						referrerPolicy="no-referrer-when-downgrade"
					/>
				</div>
			</section>

			<CtaBand withSecondary={false} />
		</>
	);
};
